import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PlanningObjectOperatorEditor.html?raw';

import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import { EmployeeExtended, HtAddressOnlineMeeting, HtPlanningObjectOperatorSpIdEnable, PlanningObjectOperator } from "./PlanningObjectOperatorTypes";
import { uiFrameTypes } from "../../moreCore/UI/Container/uiFrameTypes";
import lang from 'dojo/_base/lang';
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import DateTimeInput from '../../moreCore/UI/DateTimeInput/DateTimeInput';
import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import HintBox from '../../moreCore/UI/HintBox/HintBox';
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';
import { SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";
import EntityStore from '../../moreCore/Tools/EntityStore';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import { ExpandableSection, ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import Edit from '../../moreCore/UI/Edit/Edit';
import { StringHelpers } from "../../more/Helpers";
import "../../moreCore/UI/ClipboardTextBox/ClipboardTextBox";
import FloatingMenu from '../../moreCore/UI/Floating/Menu';

class PlanningObjectOperatorEditor extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    isNew: boolean;

    inputAlertPeriod: MdsLax<InstanceType<typeof SearchSelect>>;
    inputBaseForAlertTime: MdsLax<InstanceType<typeof SearchSelect>>;
    inputAlertTime: MdsLax<InstanceType<typeof DateTimeInput>>;

    inputPlanningObject: MdsLax<InstanceType<typeof HintBox>>;
    inputAddress: MdsLax<InstanceType<typeof HintBox>>;
    inputMasterAppointment: MdsLax<InstanceType<typeof HintBox>>;

    inputDuration: MdsLax<InstanceType<typeof NumberInput>>;

    inputDateStart: MdsLax<InstanceType<typeof DateTimeInput>>;
    inputDateEnd: MdsLax<InstanceType<typeof DateTimeInput>>;

    assignedEmployeesStore: MdsLax<InstanceType<typeof EntityStore<PlanningObjectOperator>>>;
    assignedEmployeesTable: MdsLax<InstanceType<typeof StaticTable>>;

    sectionMasterTable: MdsLax<InstanceType<typeof ExpandableSection>>;
    sectionProjectEventsTable: MdsLax<InstanceType<typeof ExpandableSection>>;
    helpdeskEntriesTableContainer: HTMLElement;
    sectionTeamsMeetingTable: MdsLax<InstanceType<typeof ExpandableSection>>;

    inputTicketId: MdsLax<InstanceType<typeof Edit>>;


    assignedEmployeeRowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_planning_object_status.description",
            "tmp_gDisp"
        ],
        headings: [
            (this as any).translate("General_Label_Status"),
            (this as any).translate("General_Label_Displayname")
        ],
        colNamesInternal: [
            "ref_planning_object_status.description",
            "tmp_gDisp"
        ],
        bgColors: [
            "ref_planning_object_status.coloration",
            null
        ]
    }

    assignedEmployeesTablelayout: StaticTable.Layout = {
        name: "assigendEmployeeTable",
        label: "assigendEmployeeTable",
        rows: [(this as any).assignedEmployeeRowConfig]
    }

    private _setupAssignedEmployeesTable(): void {
        this.assignedEmployeesTable = new StaticTable();
        this.assignedEmployeesTable.setTableLayout(this.assignedEmployeesTablelayout);
        this.assignedEmployeesTable.setupFromStore(this.assignedEmployeesStore);
        this.assignedEmployeesTable.setCyAttribute("PlanningObjectOperatorAssignedEmployeesTable");
        this.assignedEmployeesTable.placeAt(this.sectionMasterTable);
        this.assignedEmployeesTable.addDefaultRowActionButton("delete");

    }


    helpdeskEntriesStore: MdsLax<InstanceType<typeof EntityStore<HtPlanningObjectOperatorSpIdEnable>>>;
    helpdeskEntriesTable: MdsLax<InstanceType<typeof StaticTable>>;


    helpdeskEntriesRowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_vt_sp_id_enable.counter_int",
            "ref_vt_sp_id_enable.vt_sp_text_container___title",
            "ref_vt_sp_id_enable.sp_helpdesk_ticket___ref_sp_helpdesk_status.description"
        ],
        headings: [
            (this as any).translate("General_Label_No"),
            (this as any).translate("General_Label_Title"),
            (this as any).translate("General_Label_Status")
        ],
        colNamesInternal: [
            "ref_vt_sp_id_enable.counter_int",
            "vt_sp_text_container___title",
            "ref_vt_sp_id_enable.sp_helpdesk_ticket___ref_sp_helpdesk_status.description"
        ],
        bgColors: [
            null,
            null,
            "ref_vt_sp_id_enable.sp_helpdesk_ticket___ref_sp_helpdesk_status.coloration"
        ]
    }

    helpdeskEntriesTablelayout: StaticTable.Layout = {
        name: "assigendEmployeeTable",
        label: "assigendEmployeeTable",
        rows: [(this as any).helpdeskEntriesRowConfig]
    }

    private _setupHelpdeskEntriesTable(): void {
        this.helpdeskEntriesTable = new StaticTable();
        this.helpdeskEntriesTable.setTableLayout(this.helpdeskEntriesTablelayout);
        this.helpdeskEntriesTable.addDefaultRowActionButton("delete", lang.hitch(this, this._onClickDeleteTicket));
        this.helpdeskEntriesTable.setupFromStore(this.helpdeskEntriesStore);
        this.helpdeskEntriesTable.setCyAttribute("PlanningObjectOperatorHelpdeskEntriesTable");
        this.helpdeskEntriesTable.placeAt(this.helpdeskEntriesTableContainer);
    }

    private _onClickDeleteTicket(rowGroup: StaticTable.StaticTableRowGroup<HtPlanningObjectOperatorSpIdEnable>) {
        this.StandbyStart;
        let entity = rowGroup.entity;

        this.RequestManager.callfunction("Webtool_API__PlanningObjectOperator_RemoveTicket", { entityID: entity.ID, ticketID: this.inputTicketId.getValue() }, lang.hitch(this, this._onDeleteTicketResponse), lang.hitch(this, this._onDeleteTicketError));
    }

    private _onDeleteTicketResponse(response) {
        this.StandbyStop();
        this.showToast(this.translate("PlanningObjectOperator_Message_SuccessfulDelete"), "fas fa-check");
        this._onClickReloadTicketList();
    }

    private _onDeleteTicketError(error) {
        this.StandbyStop();
        console.error(error);
    }

    teamsMeetingStore: MdsLax<InstanceType<typeof EntityStore<HtAddressOnlineMeeting>>>;
    teamsMeetingTable: MdsLax<InstanceType<typeof StaticTable>>;

    teamsMeetingRowConfig: StaticTable.RowConfig = {
        attributes: [
            "c_address_1",
            "tmp_effective_email"
        ],
        headings: [
            (this as any).translate("TeamsMeetingTable_Label_Address"),
            (this as any).translate("TeamsMeetingTable_Label_Email")
        ],
        colNamesInternal: [
            "c_address_1",
            "tmp_effective_email"
        ],
        bgColors: [
            null,
            null
        ]
    }

    teamsMeetingTablelayout: StaticTable.Layout = {
        name: "teamsMeetingTable",
        label: "teamsMeetingTable",
        rows: [(this as any).teamsMeetingRowConfig]
    }

    private _teamsMeetingTableFormatter(cell: StaticTable.StaticTableCell<HtAddressOnlineMeeting>): boolean {
        let node = cell.tableCellNode;
        let entity = cell.entity;
        let name = cell.name;
        let value = cell.value;

        switch (name) {
            case "c_address_1":
                if (!entity.ref_address) {
                   //this.UiModder.domClass.add(node, "warningTXT");
                    let edit = new Edit();
                    this.UiModder.domClass.add(edit.inputNode, "warningTXT");
                    edit.setValue(value, true);
                    edit.on("change", lang.hitch(this, this._onChangeAddressEdit, entity));
                    edit.placeAt(node);
                    return true;
                }
                    
                break;
        }

        return false;
    }

    private _onChangeAddressEdit(entity: HtAddressOnlineMeeting, value: string) {
        let clonedEntity = lang.clone(entity);
        clonedEntity.c_address_1 = value;
        let regex = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$");
        if (regex.test(value)) clonedEntity.tmp_effective_email = value;
        else clonedEntity.tmp_effective_email = this.translate("TeamsMeetingTable_Label_InvalidEmail")
        this.teamsMeetingStore.changeEntry(clonedEntity, true);
    }

    private _setupAssignedTeamsMeetingTable(): void {
        this.teamsMeetingTable = new StaticTable();
        this.teamsMeetingTable.setTableLayout(this.teamsMeetingTablelayout);
        this.teamsMeetingTable.setupFromStore(this.teamsMeetingStore);
        this.teamsMeetingTable.setFormatter(lang.hitch(this, this._teamsMeetingTableFormatter));
        this.teamsMeetingTable.setCyAttribute("PlanningObjectOperatorTeamsMeetingTable");
        this.teamsMeetingTable.addDefaultRowActionButton("delete");

    }


    private _setupTables(): void {
        this._setupAssignedEmployeesTable();
        this._setupHelpdeskEntriesTable();
        this._setupAssignedTeamsMeetingTable();
    }

    private _setAssignedEmployeesExpanderMarking(): void {
        let assignedEmployees = this.assignedEmployeesStore.getCurrentCompleteList();

        if (assignedEmployees && assignedEmployees.length > 0) {
            this.sectionMasterTable.setMarking(ExpandableSectionMarkings.hasContent);
        } else {
            this.sectionMasterTable.setMarking(ExpandableSectionMarkings.empty);
        }
    }

    private _setHelpdeskEntriesExpanderMarking(): void {
        let helpdeskEntries = this.helpdeskEntriesStore.getCurrentCompleteList();

        if (helpdeskEntries && helpdeskEntries.length > 0) {
            this.sectionProjectEventsTable.setMarking(ExpandableSectionMarkings.hasContent);
        } else {
            this.sectionProjectEventsTable.setMarking(ExpandableSectionMarkings.empty);
        }
    }

    private _setTeamsMeetingExpanderMarking(): void {
        let meetingParticipants = this.teamsMeetingStore.getCurrentCompleteList();

        if (meetingParticipants && meetingParticipants.length > 0) {
            this.sectionTeamsMeetingTable.setMarking(ExpandableSectionMarkings.hasContent);
        } else {
            this.sectionTeamsMeetingTable.setMarking(ExpandableSectionMarkings.empty);
        }
    }

    setup(entityID?: string, displayMode: uiFrameTypes.DisplayMode = "dlg", tabContainerName?: string, targetNode?: HTMLElement): void {

        if (entityID) {
            this.isNew = false;
            this.StandbyStart();
            this.setStartupState("loading");
            this._loadEntityData(entityID);
        } else {
            this.isNew = true;
            let newPlanningObjectOperator: PlanningObjectOperator = {
                $Displayname: "",
                alert_check: false,
                alert_period: null,
                alert_time: null,
                base_for_alert_time: null,
                Classname: "",
                ClassPrintname: "",
                date_deadline: null,
                date_end: null,
                date_start: null,
                duration_hh_mm: "",
                EL_ht_po_op_sp_id_enable: [],
                EL_planning_object_operator_master: [],
                ID: StringHelpers.randomID(),
                is_full_time: false,
                is_to_publish_in_web: false,
                note: "",
                note_external: "",
                ref_planning_object: null,
                ref_planning_object_status: null,
                ref_vt_address_backoffice: null,
                date_start_offset: null,
                date_end_offset: null,
                date_deadline_offset: null,
                alert_time_offset: null
            }
            this.setStartupState("initial" as any); // brauchts das?? setdata führt eigentlich eh zu ready hinterher
            this.setData(newPlanningObjectOperator);
        }

        this.show(displayMode, null, tabContainerName, targetNode);
    }

    private _loadEntityData(entityID: string) {
        this.RequestManager.callfunction("Webtool_API__PlanningObjectOperator_LoadData", { entityID: entityID }, lang.hitch(this, this._onLoadResponse), lang.hitch(this, this._onLoadError));
    }

    private _onLoadResponse(response: PlanningObjectOperator): void {
        this.StandbyStop();
        response.date_start_offset = null;
        response.date_end_offset = null;
        response.date_deadline_offset = null;
        response.alert_time_offset = null;
        this.isNew = false;

        this.setData(response);
    }

    private _onLoadError(error): void {
        this.StandbyStop();
        console.error(error);
    }

    private _loadCurrentEmployee(entityID: string) {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__PlanningObjectOperator_GetCurrentEmployee", { entityID: entityID }, lang.hitch(this, this._onLoadCurrentEmployeeResponse), lang.hitch(this, this._onLoadCurrentEmployeeError));
    }

    private _onLoadCurrentEmployeeResponse(response: any): void {
        this.StandbyStop();
        this.inputAddress.setValue(response);
    }

    private _onLoadCurrentEmployeeError(error): void {
        this.StandbyStop();
        console.error(error);
    }

    private _onClickSEDBUtton(mode: string, evt: MouseEvent) {
        

        this.loadSelectEntityDialog(evt, mode, lang.hitch(this, this._onSEDCallback), null, { employeeID: this.getCurrentEmployeeId(), ID: this.getAttributeValue("ID") });
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<any>>) {
        if (items && items.length > 0) {
            for (let item of items) {


            let entity = item.entry.data;

            switch (mode) {
                case "planning_object":
                    this.setAttributeValue("ref_planning_object", entity);
                    break;
                case "address":
                    this.setAttributeValue("ref_vt_address_backoffice", entity);
                    break;
                case "assignedAddress":
                    if (this._storeHasAddress(entity)) {
                        this.showToast(this.translate("PlanningObjectOperator_Warning_AddressAssigned"), "fas fa-exclamation-triangle");
                        return;
                    }

                    let date_start = this.getAttributeValue("date_start") as Date;
                    let date_end = this.getAttributeValue("date_end") as Date;

                    if (typeof date_start === "string") {
                        date_start = new Date(date_start);
                    }
                    if (typeof date_end === "string") {
                        date_end = new Date(date_end);
                    }

                    let start_time = (date_start.getHours() < 10 ? "0" + date_start.getHours() : date_start.getHours()) + ":" + (date_start.getMinutes() < 10 ? "0" + date_start.getMinutes() : date_start.getMinutes());
                    let end_time = (date_end.getHours() < 10 ? "0" + date_end.getHours() : date_end.getHours()) + ":" + (date_end.getMinutes() < 10 ? "0" + date_end.getMinutes() : date_end.getMinutes());
                    let tmp_gDisp = entity.code + " " + start_time + "-" + end_time + " - " + this.getAttributeValue("ref_planning_object.description") +  " (" + this.getAttributeValue("ref_planning_object.ref_primarily_responsible.code") + ")"

                    let newPlanningObjectOperator: PlanningObjectOperator = {
                        $Displayname: "",
                        alert_check: false,
                        alert_period: null,
                        alert_time: null,
                        base_for_alert_time: null,
                        Classname: "",
                        ClassPrintname: "",
                        date_deadline: null,
                        date_end: null,
                        date_start: null,
                        duration_hh_mm: "",
                        EL_ht_po_op_sp_id_enable: [],
                        EL_planning_object_operator_master: [],
                        ID: StringHelpers.randomID(),
                        ref_master: this.getAttributeValue("ref_vt_address_backoffice"),
                        ref_vt_address_backoffice: entity,
                        is_full_time: false,
                        is_to_publish_in_web: false,
                        note: "",
                        note_external: "",
                        ref_planning_object: this.getAttributeValue("ref_planning_object"),
                        ref_planning_object_status: this.getAttributeValue("ref_planning_object_status"),
                        tmp_gDisp: tmp_gDisp,
                    }
                    this.assignedEmployeesStore.addEntry(newPlanningObjectOperator);
                    break;
                case "allEmployees":
                case "assignedEmployees":
                    let employeeExtended = entity as EmployeeExtended;
                    let newHtAddressOnlineMeeting: HtAddressOnlineMeeting = {
                        $Displayname: "",
                        Classname: "",
                        ClassPrintname: "",
                        c_address_1: employeeExtended.ref_vw_telecom_addresses.emailaddress,
                        tmp_effective_email: employeeExtended.ref_vw_telecom_addresses.emailaddress,
                        ref_address: employeeExtended,
                        ID: StringHelpers.randomID()
                    }
                    if (this._storeHasAddress(employeeExtended, "meetingParticipants")) this.showToast(this.translate("TeamsMeetingTable_Error_StoreHasAddress"), "fas fa-exclamation-triangle");
                    else if (this._employeeIsOrganizer(employeeExtended)) this.showToast(this.translate("TeamsMeetingTable_Error_AddressIsOrganizer"), "fas fa-exclamation-triangle");
                    else this.teamsMeetingStore.addEntry(newHtAddressOnlineMeeting);

                    
                    break;
                }
            }
        }
    }

    private _employeeIsOrganizer(address: EmployeeExtended) {
        let isOrganizer = address.ID === this.getAttributeValue("ref_vt_address_backoffice.ID");
        return isOrganizer;
    }

    private _storeHasAddress(address: Employee | EmployeeExtended, mode: string = "assignedEmployees") {
        let completelist;
        switch (mode) {
            case "assignedEmployees":
                completelist = this.assignedEmployeesStore.getCurrentCompleteList();
                for (let planningObjectOperator of completelist) {
                    if (planningObjectOperator.ref_vt_address_backoffice.ID === address.ID) return true;
                }
                return false;
                break;
            case "meetingParticipants":
                completelist = this.teamsMeetingStore.getCurrentCompleteList();
                for (let htaddressonlinemeeting of completelist) {
                    if (htaddressonlinemeeting.ref_address && htaddressonlinemeeting.ref_address.ID === address.ID) return true;
                }
                return false;
                break;
        }


    }

    private _onChangeDuration(e: number) {
        let stringDuration = e.toFixed(2);
        this.setAttributeValue("duration_hh_mm", stringDuration);

        let dateStart = this.getAttributeValue("date_start");
        if (!dateStart || dateStart.hasOwnProperty("date") && !dateStart.date) {
            
        } else {
            let newDateEnd = lang.clone(dateStart) as Date;
            newDateEnd.setTime(newDateEnd.getTime() + (e * 60 * 60 * 1000));
            this.setAttributeValue("date_end", newDateEnd);
        }
    }

    private _onChangeDateStart(value) {
        let dateEnd = this.getAttributeValue("date_end");
        let duration = parseFloat(this.getAttributeValue("duration_hh_mm"));
        if (value && value.hasOwnProperty("date") && !value.date) {
            this.setAttributeValue("date_end", null);
            this.inputDuration.setValue(0);
        } else if (value && duration || duration === 0) {
            let newDateEnd = lang.clone(value) as Date;
            newDateEnd.setTime(newDateEnd.getTime() + (duration * 60 * 60 * 1000));
            this.setAttributeValue("date_end", newDateEnd);
        } else if (value && !dateEnd) {
            let newDateEnd = lang.clone(value) as Date;
            this.setAttributeValue("date_end", newDateEnd);
        }


        if (value && !value.hasOwnProperty("date")) {
            let offset = value.getTimezoneOffset();
            offset = offset * -1;
            this.setAttributeValue("date_start_offset", offset);
        }
    }

    private _onChangeDateEnd(value) {
        let dateStart = this.getAttributeValue("date_start");
        if (value && !value.hasOwnProperty("date") && dateStart && !dateStart.hasOwnProperty("date")) {
            let duration = (value.getTime() - dateStart.getTime()) / 1000 / 60 / 60;
            this.inputDuration.setValue(duration);
        } else if (value && value.hasOwnProperty("date") && !value.date && dateStart && !dateStart.hasOwnProperty("date")) {
            this.setAttributeValue("date_end", lang.clone(dateStart));
        } else if (dateStart && dateStart.hasOwnProperty("date") && !dateStart.date) {
            this.setAttributeValue("date_end", null);
        }



        if (value && !value.hasOwnProperty("date")) {
            let offset = value.getTimezoneOffset();
            offset = offset * -1;
            this.setAttributeValue("date_end_offset", offset);
        }
    }

    private _onChangeDateDeadline(value) {
        if (value && !value.hasOwnProperty("date")) {
            let offset = value.getTimezoneOffset();
            offset = offset * -1;
            this.setAttributeValue("date_deadline_offset", offset);
        }
    }

    private _onChangeAlertTime(value) {
        if (value && !value.hasOwnProperty("date")) {
            let offset = value.getTimezoneOffset();
            offset = offset * -1;
            this.setAttributeValue("alert_time_offset", offset);
        }
    }

    private _onChangeAlertCheck(value) {
        this.inputAlertPeriod.setReadonly(!value);
        this.inputBaseForAlertTime.setReadonly(!value);
        let baseForAlertTime = this.getAttributeValue("base_for_alert_time");
        if (baseForAlertTime && baseForAlertTime.value === "alert_time") {
            this.inputAlertTime.setReadonly(!value);
            this.inputAlertPeriod.setReadonly(value);
        }
    }

    private _onChangeBaseForAlertTime(value) {
        let alertCheck = this.getAttributeValue("alert_check");
        if (alertCheck && value && value.value === "alert_time") this.inputAlertTime.setReadonly(false);
        else this.inputAlertTime.setReadonly(true);
        if (alertCheck && value && value.value === "alert_time") this.inputAlertPeriod.setReadonly(true);
        else this.inputAlertPeriod.setReadonly(false);
    }

    private _onChangeIsFullTime(value) {
        let dateStart = this.getAttributeValue("date_start") as Date;

        if (dateStart && typeof dateStart === "string") {
            dateStart = new Date(dateStart);
        }

        if (value && dateStart && !dateStart.hasOwnProperty("date")) {
            let newDateStart = lang.clone(dateStart);
            newDateStart.setHours(0, 0, 0, 0);
            let newDateEnd = lang.clone(dateStart);
            newDateEnd.setHours(23, 59, 59, 0);
            this.setAttributeValue("date_start", newDateStart);
            this.setAttributeValue("date_end", newDateEnd);
        }
    }

    private _onClickToday() {
        let newDateStart = new Date();
        newDateStart.setHours(8, 0, 0, 0);
        let newDateEnd = new Date();
        newDateEnd.setHours(17, 0, 0, 0);
        this.setAttributeValue("date_start", newDateStart);
        this.setAttributeValue("date_end", newDateEnd);
    }

    private _onClickTransferNote() {
        let note = this.getAttributeValue("note");
        this.setAttributeValue("note_external", note);
    }

    protected _onChanged(attributeName: string, value: any) {

        switch (attributeName) {
            case "alert_check":
                this._onChangeAlertCheck(value);
                break;
            case "base_for_alert_time":
                this._onChangeBaseForAlertTime(value);
                break;
            case "date_start":
                this._onChangeDateStart(value);
                break;
            case "date_end":
                this._onChangeDateEnd(value);
                break;
            case "date_deadline":
                this._onChangeDateDeadline(value);
                break;
            case "is_full_time":
                this._onChangeIsFullTime(value);
                break;
            case "alert_time":
                this._onChangeAlertTime(value);
                break;
        }
    }

    private _onAssignedEmployeesStoreChange() {
        this._setAssignedEmployeesExpanderMarking();
        let diffData = this.assignedEmployeesStore.getDiffData(true);
        this.setAttributeValue("assignedAddressesDiffData", diffData);
    }

    private _onHelpdeskTicketsStoreChange() {
        this._setHelpdeskEntriesExpanderMarking();
        let diffData = this.helpdeskEntriesStore.getDiffData(true);
        //this.setAttributeValue("helpdeskEntriesDiffData", diffData);
    }

    private _onTeamsMeetingStoreChange() {
        this._setTeamsMeetingExpanderMarking();
        let diffData = this.teamsMeetingStore.getDiffData(true);
        this.setAttributeValue("teamsMeetingDiffData", diffData);
    }

    private _onClickReloadMasterList() {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__PlanningObjectOperator_GetAssignedAssociatesListValues", { entityID: this.getAttributeValue("ID") }, lang.hitch(this, this._onReloadMasterListResponse), lang.hitch(this, this._onReloadMasterListError));
    }

    private _onReloadMasterListResponse(response: Array<PlanningObjectOperator>) {
        this.StandbyStop();
        //this.setAttributeValue("EL_planning_object_operator_master", response);
        this.setAttributeValue("assignedAddressesDiffData", null);
        this.assignedEmployeesStore.setup(response);
        this._setAssignedEmployeesExpanderMarking();

    }

    private _onReloadMasterListError(error) {
        this.StandbyStop();
        console.error();
    }

    private _onClickNewAssignedAddress(e: MouseEvent) {
        this.loadSelectEntityDialog(e, "assignedAddress", lang.hitch(this, this._onSEDCallback))
    }

    private _onClickReloadTicketList() {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__PlanningObjectOperator_GetHelpdeskTicketsListValues", { entityID: this.getAttributeValue("ID") }, lang.hitch(this, this._onReloadTicketListResponse), lang.hitch(this, this._onRealoadTicketListError));

    }

    private _onReloadTicketListResponse(response: Array<HtPlanningObjectOperatorSpIdEnable>) {
        this.StandbyStop();
        //this.setAttributeValue("EL_ht_po_op_sp_id_enable", response);
        //this.setAttributeValue("helpdeskEntriesDiffData", null);
        this.helpdeskEntriesStore.setup(response);
        this._setHelpdeskEntriesExpanderMarking();
    }

    private _onRealoadTicketListError(error) {
        console.error(error);
    }

    private _onClickNewTicket() {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__PlanningObjectOperator_AddTicket", { entityID: this.getAttributeValue("ID"), ticketID: this.inputTicketId.getValue() }, lang.hitch(this, this._onNewTicketResponse), lang.hitch(this, this._onNewTicketError));
        this.inputTicketId.setValue("", true);
    }

    private _onNewTicketResponse(response) {
        this.StandbyStop();
        this._onClickReloadTicketList();
    }

    private _onNewTicketError(error) {
        this.StandbyStop();
        this.showToast(error?.Message, "fas fa-exclamation-triangle");
        console.error(error);
    }

    private _onClickSave() {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__PlanningObjectOperator_SaveEntity", { entityID: this.getAttributeValue("ID"), isNew: this.isNew, changedData: this.getChangedData() }, lang.hitch(this, this._onSaveDataResponse), lang.hitch(this, this._onSaveDataError));
    }

    private _onSaveDataResponse(response) {
        this.StandbyStop();
        this.showToast(this.translate("PlanningObjectOperator_Message_SaveSuccess"), "fas fa-check")
        this._loadEntityData(response.entityID);
        this.emit("saved");
    }

    private _onSaveDataError(error) {
        console.error(error);
        this.showToast(this.translate("PlanningObjectOperator_Message_SaveError"), "fas fa-times")
        this.StandbyStop();
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let title;
        if (!this.isNew) title = this.getAttributeValue("$Displayname");
        else title = this.translate("General_Label_NewPlanningObjectOperator");

        this.inputMasterAppointment.setInputNodeReadonly(true);
        let masterAppointment = this.getAttributeValue("ref_master");
        if (masterAppointment) {
            this.hideNode(this.inputMasterAppointment, false);
            this.inputMasterAppointment.addInlineButton(lang.hitch(this, this._onClickGotoMasterAppointment, masterAppointment), "gotoMasterAppointment", "fas fa-external-link-square-alt");
        }


        let dateStart = this.getAttributeValue("date_start");
        if (dateStart && typeof dateStart === "string") {
            let newDateStart = new Date(dateStart);
            this.setAttributeValue("date_start", newDateStart);
        }

        let dateEnd = this.getAttributeValue("date_end");
        if (dateEnd && typeof dateEnd === "string") {
            let newDateEnd = new Date(dateEnd);
            this.setAttributeValue("date_end", newDateEnd);
        }

        let durationString = this.getAttributeValue("duration_hh_mm");
        let durationNumber = parseFloat(durationString);
        this.inputDuration.setValue(durationNumber, true);

        let assignedAddresses = this.getAttributeValue("EL_planning_object_operator_master");
        let helpdeskEntries = this.getAttributeValue("EL_ht_po_op_sp_id_enable");
        let meetingParticipants = this.getAttributeValue("EL_ht_address_onlinemeeting_planning_object_operator");

        this.assignedEmployeesStore.setup(assignedAddresses);
        this.helpdeskEntriesStore.setup(helpdeskEntries);
        this.teamsMeetingStore.setup(meetingParticipants);

        this._setHelpdeskEntriesExpanderMarking();
        this._setAssignedEmployeesExpanderMarking();
        this._setTeamsMeetingExpanderMarking();

        let baseForAlertTime = this.getAttributeValue("base_for_alert_time");
        let alertCheck = this.getAttributeValue("alert_check");

        this._onChangeBaseForAlertTime(baseForAlertTime);
        this._onChangeAlertCheck(alertCheck);

        this.setTitles(title);

        if (!this.isNew) {
            this.createDefaultButton("rollback", lang.hitch(this, this._onClickRollback), false);
            this.createDefaultButton("reload", lang.hitch(this, this._onClickReload), true, "secondary");
            this.createDefaultButton("delete", lang.hitch(this, this._onClickDelete), true, "secondary");
        } else {
            
        }

        this.hideNode(this.sectionProjectEventsTable, this.isNew);

        this.setAttributeValue("date_end_offset", null);
        this.setAttributeValue("date_start_offset", null);
    }

    protected afterReady(): void {
        super.afterReady.apply(this, arguments as any);

        if (this.isNew) this._loadCurrentEmployee(this.getCurrentEmployeeId());

        this.emit("afterReady");
    }

    private _onClickGotoMasterAppointment(masterAppointment: PlanningObjectOperator) {
        let editor = new PlanningObjectOperatorEditor();
        editor.setup(masterAppointment.ID);
    }

    private _onClickRollback() {
        this.rollback();
    }

    private _onClickReload() {
        let entityID = this.getAttributeValue("ID");
        this._loadEntityData(entityID);
    }

    private _onClickDelete() {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__PlanningObjectOperator_DeleteEntity", { entityID: this.getAttributeValue("ID") }, lang.hitch(this, this._onDeleteResponse), lang.hitch(this, this._onDeleteError))
    }

    private _onDeleteResponse(response) {
        this.StandbyStop();
        this.showToast(this.translate("PlanningObjectOperator_Message_DeleteSuccess"), "fas fa-check")
        this.close();
        this.emit("deleted");
    }

    private _onDeleteError(error) {
        this.StandbyStop();
        this.showToast(this.translate("PlanningObjectOperator_Message_DeleteError"), "fas fa-times")
        console.error(error);
    }

    protected onDirtyChange(newState: boolean) {
        this.enableButton("save", newState);
        this.enableButton("rollback", newState);
    }

    setDateStart(dateStart: Date): void {
        this.inputDateStart.setValue(dateStart);
    }

    setDateEnd(dateEnd: Date): void {
        this.inputDateEnd.setValue(dateEnd);
    }

    _onClickNewMeetingAddress(evt): void {
        let menu = new FloatingMenu();
        menu.addEntry({
            label: this.translate("TeamsMeetingTable_Label_AddAddress"),
            icon: "fas fa-plus-circle",
            callback: lang.hitch(this, this._onClickAddEmployee),
            heading: this.translate("TemsMeetingTable_Label_AddParticipant")
        });
        menu.addEntry({
            label: this.translate("TeamsMeetingTable_Label_AddPlaintextEmployee"),
            icon: "fas fa-plus-circle",
            callback: lang.hitch(this, this._onClickAddPlaintextEmployee),
            heading: this.translate("TemsMeetingTable_Label_AddParticipant")
        });

        menu.open(evt);
    }

    _onClickAddEmployee(evt): void {
        this._onClickSEDBUtton("addressMeeting", evt);
    }

    _onClickAddAssignedEmployee(evt): void {
        this._onClickSEDBUtton("assignedEmployees", evt);
    }

    _onClickAddPlaintextEmployee(evt): void {
        let entity: HtAddressOnlineMeeting = {
            $Displayname: "",
            Classname: "",
            ClassPrintname: "",
            c_address_1: "",
            ID: StringHelpers.randomID(),
            ref_address: null,
            tmp_effective_email: this.translate("TeamsMeetingTable_Label_MailEmpty")
        }

        this.teamsMeetingStore.addEntry(entity);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API__PlanningObjectOperator_SED_GetConfig";

        this.inputAddress.addInlineButton(lang.hitch(this, this._onClickSEDBUtton, "address"));
        this.inputPlanningObject.addInlineButton(lang.hitch(this, this._onClickSEDBUtton, "planning_object"));
        this.inputDuration.setUnit("h");
        this.inputDuration.setPlaces(2);
        this.inputDuration.setStep("0.01")
        this.inputDuration.on("change", lang.hitch(this, this._onChangeDuration));

        this.assignedEmployeesStore = new EntityStore();
        this.assignedEmployeesStore.on("change", lang.hitch(this, this._onAssignedEmployeesStoreChange));
        this.helpdeskEntriesStore = new EntityStore();
        this.helpdeskEntriesStore.on("change", lang.hitch(this, this._onHelpdeskTicketsStoreChange));
        this.teamsMeetingStore = new EntityStore();
        this.teamsMeetingStore.on("change", lang.hitch(this, this._onTeamsMeetingStoreChange));

        this.setAttributeValue("assignedAddressesDiffData", null);

        //this.setAttributeValue("helpdeskTicketsDiffData", null);

        this._setupTables();

        this.createDefaultButton("save", lang.hitch(this, this._onClickSave), false);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PlanningObjectOperatorEditor);